const USER_SESSION_KEYS = [
  "auth_mobile",
  "auth_name",
  "checkoutInput",
  "email",
  "profile_address",
  "profile_city",
  "profile_email",
  "profile_full_name",
  "profile_gst_no",
  "profile_mobile",
  "profile_pincode",
  "profile_state",
  "token",
  "user_id",
];

export function clearStoredUserSession({ preserveCart = true } = {}) {
  if (typeof window === "undefined") {
    return;
  }

  USER_SESSION_KEYS.forEach((key) => window.localStorage.removeItem(key));

  if (!preserveCart) {
    window.localStorage.removeItem("carts");
  }
}

export function clearAllLocalStorage() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.clear();
}

export function saveAuthenticatedProfile(profile = {}, fallback = {}) {
  if (typeof window === "undefined") {
    return;
  }

  const name =
    profile.first_name ||
    profile.name ||
    profile.full_name ||
    fallback.name ||
    "";
  const mobile =
    profile.phone_no ||
    profile.mobile ||
    profile.phone ||
    fallback.mobile ||
    "";
  const userId =
    profile.id ||
    profile.user_id ||
    profile.customer_id ||
    fallback.userId ||
    "";

  if (name) {
    window.localStorage.setItem("auth_name", name);
    window.localStorage.setItem("profile_full_name", name);
  }

  if (mobile) {
    window.localStorage.setItem("auth_mobile", mobile);
    window.localStorage.setItem("profile_mobile", mobile);
  }

  if (userId) {
    window.localStorage.setItem("user_id", String(userId));
  }

  const profileFields = {
    profile_email: profile.email,
    profile_gst_no: profile.gst_no || profile.gst_number,
    profile_address: profile.address,
    profile_city: profile.city,
    profile_pincode: profile.pincode,
    profile_state: profile.state,
  };

  Object.entries(profileFields).forEach(([key, value]) => {
    if (value) {
      window.localStorage.setItem(key, value);
    }
  });
}